






















































import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import AddSpaceDialog from './components/add-space-dialog.vue';
/**
 * 空间列表
 *
 * @author liyuyao
 * @date 01/11/2019
 */
@Component({
    components: {
        AddSpaceDialog
    }
})
export default class SpaceList extends PaginationMixin {
    @State(state => state.cti.userInfo)
    userInfo: CommonTypes.UserInfoItem;

    spaceList: CommonTypes.SpaceItem[] = [];
    addSpaceVisible: Boolean = false;
    editSpace: Boolean = false;
    spaceInfo: CommonTypes.SpaceItem = null;

    tableLoading: Boolean = true;
    firstLoading: Boolean = true;
    $mtd: any;
    async created() {
        await this.getMySpace();
        this.firstLoading = false;
    }
    async getMySpace() {
        this.tableLoading = true;
        // this.spaceList = [{
        //     'createdAt': 1596460586251,
        //     'accessLink': '123.tt.sankuai.com',
        //     'accessLinkPrefix': '123',
        //     'createdBy': 'xujie11',
        //     'org': '基础技术研发',
        //     'formListLink': '123.tt.sankuai.com/custom/form/list',
        //     'name': '测试tt空间32',
        //     'id': 3
        // }];
        try {
            const res = await api.spaceApi.getMySpace({
                cn: this.currentPage,
                sn: this.limit
            });
            const { code, data } = res;
            if (code === 200) {
                this.spaceList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getMySpace();
                }
            }
        } catch (e) {
            this.spaceList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getMySpace();
    }
    // 进入空间详情
    handleDetail(id: number) {
        this.$router
            .push({
                name: 'space_admin',
                params: {
                    id: `${id}`
                }
            })
            .catch(e => e);
    }
    // 编辑空间基本信息
    handleEditSpace(row) {
        this.spaceInfo = row;
        this.editSpace = true;
        this.addSpaceVisible = true;
    }
    handleAddSpace() {
        this.editSpace = false;
        this.addSpaceVisible = true;
    }
    formatOrg(org) {
        const orgArr = (org && org.split('-')) || [];
        if (orgArr[0] === 'IPH') {
            orgArr.shift();
        }
        return orgArr.join('/');
    }
}
